<template>
  <section class="bg-white py-8">
    <div class="container mx-auto flex items-center flex-wrap pt-4 pb-12">


      

      <NftWithdrawOnBurn v-for="tokenId in [fomoTokenId, fudTokenId]" :key="tokenId" :tokenId="tokenId" />

      <Nft v-for="tokenId in fomoContributionTokenIds" :key="tokenId" :tokenId="tokenId" />
      <Nft v-for="tokenId in fudContributionTokenIds" :key="tokenId" :tokenId="tokenId" />

    </div>
  </section>

</template>

<script>

import Nft from './Nft.vue';
import NftWithdrawOnBurn from './NftWithdrawOnBurn.vue';

export default {
  name: "Collection",
  props: {
    collectionId:{
      type: Number,
      required: true,
      default: 0
    }
  },
  async mounted(){
    let collection = await this.artburnDapp.methods.collection(this.collectionId).call();
    this.title = collection.title;
    this.description = collection.description;
    this.balance = collection.balance;

  },
  data: () => {
    return {
      title:'',
      description:'',
      balance:'0',
      fomoTokenId:11,
      fudTokenId:10,
      fomoContributionTokenIds: [12,1,9,7,15,2,16,8],
      fudContributionTokenIds: [17,5,18,4,13,3,14,6],
      numberOfTokens:0
    }
  },

  components: {
    Nft,
    NftWithdrawOnBurn
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe1by1 {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.iframe1by1 > iframe {
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.hover\:grow {
  transition: all 0.3s;
  transform: scale(1);
}

.hover\:grow:hover {
  transform: scale(1.02);
}
</style>
